/**
 * SessionManager: gerencia sessionToken, hmacSecret e ações correlatas.
 */
export class SessionManager {
  private sessionToken: string | null = null;
  private hmacSecret: string | null = null;
  private flushQueue?: () => void;
  private exempt?: Set<string>;

  configure(options: { onFlushQueue?: () => void; tokenExemptActions?: Set<string> } = {}): void {
    this.flushQueue = options.onFlushQueue;
    this.exempt = options.tokenExemptActions;
  }

  setSessionToken(token: string | null | undefined): void {
    const normalized = token == null ? null : String(token);
    this.sessionToken = normalized;
    (window as any).sessionToken = normalized as any;
    if (normalized && this.flushQueue) {
      try { this.flushQueue(); } catch {}
    }
  }

  getSessionToken(): string | null {
    return this.sessionToken ?? ((window as any)?.sessionToken ?? null);
  }

  /**
   * Define o HMAC secret compartilhado entre frontend e backend.
   * Este secret é usado para assinar mensagens e garantir autenticidade.
   * 
   * @param secret Chave secreta HMAC (geralmente recebida via bootstrap)
   */
  setHmacSecret(secret: string | null | undefined): void {
    const normalized = secret == null ? null : String(secret);
    this.hmacSecret = normalized;
  }

  /**
   * Retorna o HMAC secret atual.
   * 
   * @returns HMAC secret ou null se não configurado
   */
  getHmacSecret(): string | null {
    return this.hmacSecret;
  }

  isTokenExempt(action: string): boolean {
    return Boolean(this.exempt && this.exempt.has(action));
  }
}


